module.exports = __webpack_public_path__ + "img/industry_chain.f452e712.png";